module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/pdf-3fa92281020f448a50d540d268e7fa3e.svg";